import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { MyProfile } from 'components/Settings/Components/UserProfile/components/myProfile';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const MyProfilePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userProfile.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.userProfile.title} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <MyProfile />
            </MainContent>
        </PageContainer>
    );
};
